export interface AnalyticsData {
  totalStudents: number
  avgScore: number
  taskCompletion: number
  engagement: "High" | "Medium" | "Low"
  termProgress: number
  daysLeft: number
  hoursLeft: number
}

export interface CareerPathData {
  name: string
  percentage: number
  color: string
}

export interface ClassProgress {
  subject: string
  grade: string
  module: string
  progress: number
  icon: string
  color: string
}

export interface CalendarEvent {
  date: number
  type: "exam" | "holiday" | "event" | "normal"
  title?: string
  color?: string
}

export const analyticsData: AnalyticsData = {
  totalStudents: 1248,
  avgScore: 82,
  taskCompletion: 94,
  engagement: "High",
  termProgress: 85,
  daysLeft: 14,
  hoursLeft: 6,
}

export const careerPathData: CareerPathData[] = [
  { name: "STEM", percentage: 65, color: "#21a193" },
  { name: "Arts", percentage: 45, color: "#284e8c" },
  { name: "Science", percentage: 30, color: "#4F46E5" },
  { name: "Commercial", percentage: 55, color: "#2DD4BF" },
  { name: "Sports", percentage: 25, color: "#A78BFA" },
]

export const classProgressData: ClassProgress[] = [
  { subject: "Science & Tech", grade: "Grade 5", module: "Module 3", progress: 78, icon: "Beaker", color: "#21a193" },
  { subject: "Mathematics", grade: "Grade 6", module: "Algebra", progress: 92, icon: "Calculator", color: "#284e8c" },
  { subject: "Language Arts", grade: "Grade 4", module: "Reading", progress: 64, icon: "BookOpen", color: "#4F46E5" },
  { subject: "Creative Arts", grade: "Grade 5", module: "Sketching", progress: 45, icon: "Palette", color: "#F59E0B" },
]

export const studyHoursData = [
  { day: "Mon", hours: 45, active: false },
  { day: "Tue", hours: 60, active: false },
  { day: "Wed", hours: 85, active: true },
  { day: "Thu", hours: 30, active: false },
  { day: "Fri", hours: 55, active: false },
  { day: "Sat", hours: 20, active: false },
]

export const calendarEvents: CalendarEvent[] = [
  { date: 3, type: "exam", title: "Mid-term Exams Begin", color: "#21a193" },
  { date: 4, type: "exam", color: "#21a193" },
  { date: 5, type: "exam", color: "#21a193" },
  { date: 11, type: "event", title: "Science Fair", color: "#4F46E5" },
  { date: 25, type: "holiday", title: "Mid-Term Break Starts", color: "#284e8c" },
  { date: 26, type: "holiday", color: "#284e8c" },
  { date: 27, type: "holiday", color: "#284e8c" },
]
